import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { CheckCircle2, AlertTriangle, Plus, Minus } from 'lucide-react';
import { PRODUCTS } from './MetaPixel';
export const ProductTomos = () => {
  const [openTomo, setOpenTomo] = useState<number | null>(null);
  const tomos = [{
    emoji: '📗',
    title: 'Nivel 1 — Mentalidad e Identidad Pro',
    sessions: '50 páginas',
    months: 'Base del sistema',
    desc: 'El cambio de mentalidad de barbero a dueño. Costo de la silla vacía. El número mágico. Cliente ideal.',
    color: 'bg-[#C9A84C]',
    borderColor: 'border-t-[#C9A84C]'
  }, {
    emoji: '📘',
    title: 'Nivel 2 — Configuración de la Máquina',
    sessions: '50 páginas',
    months: 'Infraestructura técnica',
    desc: 'Meta Business Suite, WhatsApp Business extremo, Pixel, anti-bloqueos y validación final.',
    color: 'bg-[#3B82F6]',
    borderColor: 'border-t-[#3B82F6]'
  }, {
    emoji: '📕',
    title: 'Nivel 3 — Anuncios Imantados',
    sessions: '50 páginas',
    months: 'El motor de citas',
    desc: 'Oferta irresistible, video-ads de 15 segundos, segmentación de 2km, estrategia del dólar diario.',
    color: 'bg-[#C0392B]',
    borderColor: 'border-t-[#C0392B]'
  }, {
    emoji: '📙',
    title: 'Nivel 4 — Cierre Maestro en WhatsApp',
    sessions: '50 páginas',
    months: 'Conversión de dinero',
    desc: 'El guion exacto para convertir consultas en citas. Scripts probados. Manejo de objeciones.',
    color: 'bg-[#F59E0B]',
    borderColor: 'border-t-[#F59E0B]'
  }, {
    emoji: '📓',
    title: 'Nivel 5 — La Agenda Blindada',
    sessions: '50 páginas',
    months: 'Fidelización y retención',
    desc: 'Sistema de turnos anticipados, reactivación de clientes fríos y programa de referidos.',
    color: 'bg-[#8B5CF6]',
    borderColor: 'border-t-[#8B5CF6]'
  }, {
    emoji: '📔',
    title: 'Nivel 6 — Escalamiento e Imperio',
    sessions: '50 páginas',
    months: 'Libertad y crecimiento',
    desc: 'Segunda silla, equipo, delegación y expansión. Del barbero al dueño de barbería.',
    color: 'bg-[#27AE60]',
    borderColor: 'border-t-[#27AE60]'
  }];
  const features = ['Objetivo del nivel claro', 'Herramientas descargables', 'Scripts listos para copiar', 'Ejercicios de implementación', 'Casos reales de barbería', 'Checklist de acción semanal', 'Una página por concepto', 'Abrís, leés 30 segundos y ejecutás'];
  const featureChips = ['✅ Sistema de anuncios Meta Ads', '✅ Guiones de WhatsApp listos', '✅ Estrategia dólar diario', '✅ Fidelización y retención', '✅ Plan de escalamiento', '✅ 300 páginas de sistema'];
  return <Section className="bg-bg-base !pt-6 md:!pt-10" data-id="element-18" data-mp="gh95rtt9bmin">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-19" data-mp="lji0auls2wmv">
        {/* Yellow trust pill */}
        <div className="flex justify-center mb-4 md:mb-5" data-id="element-20" data-mp="vmwtem8vq2t4">
          <span className="inline-flex items-center gap-1.5 font-sans font-semibold uppercase tracking-[1.5px] text-[9px] md:text-[10px] text-brandOrange bg-brandOrange/10 border border-brandOrange/30 rounded-full px-3 py-1" data-id="element-21" data-mp="vk0scp1qiy0g">
            🏆 Sistema N°1 para Barberos
          </span>
        </div>

        <h2 className="font-display font-extrabold uppercase md:text-[64px] gold-metallic mb-3 md:mb-4 text-[40px] leading-[1.1]" data-id="element-22" data-mp="hoow2d7xkzhf">
          MEGAPACK BARBERO PRO™
        </h2>
        <p className="font-sans text-[16px] md:text-[20px] leading-[1.5] md:leading-[1.7] text-txt-primary max-w-2xl mx-auto" data-id="element-23" data-mp="19eblrjoofgcu">
          6 Niveles + 6 Bonos — El sistema completo para llenar tu agenda,
          cobrar más y te conviertas en un experto de la publicidad.
        </p>
      </FadeIn>

      {/* Hero mockup — moved up under title */}
      <FadeIn delay={0.15} className="mb-8 md:mb-12" data-id="element-24" data-mp="1scw8z0ng61l7">
        <img src="https://cdn.magicpatterns.com/uploads/sFEQjEmUsZK8vJ3cEmMSwK/mockup_principal_sticker.png" alt="MEGAPACK BARBERO PRO" className="w-full max-w-[600px] mx-auto h-auto object-contain drop-shadow-2xl" data-id="element-25" data-mp="1sbcthc9m7ukh" />
      </FadeIn>

      {/* 6 colored Nivel strip */}
      <FadeIn delay={0.2} className="mb-5 md:mb-7" data-id="element-26" data-mp="13vrdbx2khg86">
        <div className="grid grid-cols-6 gap-2 md:gap-3 max-w-3xl mx-auto px-2 md:px-0" data-id="element-27" data-mp="17uru7a1hi8sj">
          {tomos.map((tomo, i) => {
          // Swap only Nivel 1 (i===0) and Nivel 6 (i===5) colors in this strip
          const stripColor = i === 0 ? tomos[5].color : i === 5 ? tomos[0].color : tomo.color;
          return <div key={i} className={`${stripColor} aspect-[3/4] rounded-[10px] md:rounded-[14px] flex items-center justify-center text-center shadow-[0_4px_12px_rgba(0,0,0,0.4)] relative overflow-hidden`} data-id="element-28" data-mp="1msk8xzz7it5o" data-mpi={i}>
                <div className="absolute inset-0 bg-gradient-to-b from-white/15 to-transparent h-1/2 pointer-events-none" data-id="element-29" data-mp="2jaylllbk0scc"></div>
                <span className="font-display uppercase tracking-[1px] text-white text-[10px] md:text-[14px] leading-[1.1] drop-shadow-md relative z-10 px-1" data-id="element-30" data-mp="7u557bn5z5j2">
                  Nivel
                  <br data-id="element-31" data-mp="hkho6zfbyqn3" />
                  {i + 1}
                </span>
              </div>;
        })}
        </div>
      </FadeIn>

      {/* "6 Niveles Completos" badge pill */}
      <FadeIn delay={0.25} className="flex justify-center mb-7 md:mb-10" data-id="element-32" data-mp="3l1ge3q5gd99h">
        <span className="inline-flex items-center font-display uppercase tracking-[2px] text-[12px] md:text-[14px] text-black bg-brandOrange rounded-full px-5 py-1.5 md:px-6 md:py-2" data-id="element-33" data-mp="3g3erwwcqctts">
          6 Niveles Completos
        </span>
      </FadeIn>

      {/* Feature chip pills */}
      <FadeIn delay={0.3} className="mb-8 md:mb-12" data-id="element-34" data-mp="3q3p7gnm8mdc4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 md:gap-2 max-w-xl mx-auto px-2" data-id="element-35" data-mp="1a95gheyhyga5">
          {featureChips.map((chip, i) => <span key={i} className="inline-flex items-center gap-1.5 bg-bg-card border border-brandOrange/40 text-txt-primary font-sans font-semibold uppercase tracking-[0.5px] text-[9.5px] md:text-[11px] rounded-full px-2.5 py-1 md:px-3 md:py-1.5 whitespace-nowrap" data-id="element-36" data-mp="15dgb2uzsq55x" data-mpi={i}>
              <span className="text-success text-[10px] md:text-[12px] leading-none" data-id="element-37" data-mp="1rbkmmetxhewf">
                ✅
              </span>
              <span className="truncate" data-id="element-38" data-mp="toc4mtt4ynz6">{chip.replace('✅ ', '')}</span>
            </span>)}
        </div>
      </FadeIn>

      {/* EL OBJETIVO — moved here, under the feature checklist */}
      <FadeIn delay={0.32} className="text-center max-w-2xl mx-auto mb-8 md:mb-12" data-id="element-39" data-mp="13lgjs9okdj6h">
        <span className="inline-flex items-center gap-1.5 font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] text-brandOrange bg-brandOrange/10 border border-brandOrange/40 rounded-full px-3 py-1.5 mb-4" data-id="element-40" data-mp="18cyj6taxvbpc">
          🎯 EL OBJETIVO
        </span>
        <p className="font-display uppercase tracking-[0.5px] text-[20px] md:text-[28px] leading-[1.2] text-txt-primary" data-id="element-41" data-mp="2t6ozq95ynh8m">
          Que te vuelvas un{' '}
          <span className="text-brandOrange" data-id="element-42" data-mp="2p5lmzvj7m1bm">barbero experto en marketing</span>{' '}
          y <span className="text-brandOrange" data-id="element-43" data-mp="2k4pjhj2rsh6q">diferente al resto.</span>
        </p>
        <p className="font-sans md:text-[15px] text-txt-primary opacity-70 mt-3 text-[16px]" data-id="element-44" data-mp="2f7pdf85x7efm">
          No otro barbero más en Instagram. Uno que entiende el negocio, llena
          la agenda y cobra lo que vale.
        </p>
      </FadeIn>

      {/* "Lo que recibís" pill header */}
      <FadeIn delay={0.35} className="flex justify-center mb-7 md:mb-10" data-id="element-45" data-mp="21f9eojk1y2ki">
        <span className="inline-flex items-center gap-2 bg-bg-card border border-brandOrange/40 rounded-full px-5 py-2 md:px-7 md:py-3" data-id="element-46" data-mp="21d527d837v8m">
          <span className="text-[16px] md:text-[20px]" data-id="element-47" data-mp="1rhl9ezotlco3">📦</span>
          <span className="font-display uppercase tracking-[1.5px] text-[14px] md:text-[18px] text-txt-primary" data-id="element-48" data-mp="1rj67v0e99fr8">
            Lo que recibís:
          </span>
        </span>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mb-12 md:mb-16 max-w-3xl md:max-w-none mx-auto" data-id="element-49" data-mp="3babkcwoj1xmo">
        {tomos.map((tomo, i) => {
        const isOpen = openTomo === i;
        // Map the bg color class to a top-bar background color
        const topBarColor = tomo.color;
        return <FadeIn key={i} delay={Math.min(i * 0.04, 0.18)} data-id="element-50" data-mp="2rop2gu19el93" data-mpi={i}>
              <div className="bg-bg-card rounded-[14px] border border-line overflow-hidden relative" data-id="element-51" data-mp="2rn5mz5nfge8d">
                {/* Top colored accent bar */}
                <div className={`${topBarColor} h-[3px] w-full`} data-id="element-52" data-mp="2ioae1lt00q1d"></div>

                <button type="button" onClick={() => setOpenTomo(isOpen ? null : i)} className="w-full flex items-center gap-3 px-3 py-2.5 md:px-4 md:py-3 text-left" aria-expanded={isOpen} data-id="element-53" data-mp="2ilxqmt4h1ngx">
                  {/* Emoji book icon */}
                  <span className="text-[24px] md:text-[28px] leading-none shrink-0" data-id="element-54" data-mp="1u2cec9dag206">
                    {tomo.emoji}
                  </span>

                  {/* Title + pills */}
                  <div className="min-w-0 flex-1" data-id="element-55" data-mp="2411yy9wkk0k4">
                    <h3 className="font-sans font-bold text-[13px] md:text-[15px] text-txt-primary leading-[1.2] mb-1.5" data-id="element-56" data-mp="242mthzivvjhz">
                      {tomo.title}
                    </h3>
                    <div className="flex items-center gap-1.5 flex-wrap" data-id="element-57" data-mp="2d0opg0nrflye">
                      <span className="font-sans font-bold uppercase tracking-[0.5px] text-[9px] md:text-[10px] text-brandOrange bg-brandOrange/15 rounded-md px-1.5 py-0.5" data-id="element-58" data-mp="290emyxz6fdoa">
                        {tomo.sessions}
                      </span>
                      <span className="font-sans font-bold uppercase tracking-[0.5px] text-[9px] md:text-[10px] text-txt-muted bg-bg-highlight rounded-md px-1.5 py-0.5" data-id="element-59" data-mp="2ht02843ln28d">
                        {tomo.months}
                      </span>
                    </div>
                  </div>

                  {/* Plus / minus toggle */}
                  <span className="shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-bg-highlight flex items-center justify-center text-txt-primary" data-id="element-60" data-mp="2qzdfe7pwniqi">
                    {isOpen ? <Minus size={14} data-id="element-61" data-mp="2h8irz00xad3h" /> : <Plus size={14} data-id="element-62" data-mp="2h7z6j9c2d6kp" />}
                  </span>
                </button>

                {/* Expanded description */}
                {isOpen && <div className="px-3 pb-3 md:px-4 md:pb-4 pt-0" data-id="element-63" data-mp="39vbthkm4zgej">
                    <p className="font-sans text-[12.5px] md:text-[14px] leading-[1.5] text-txt-primary opacity-80 pl-[36px] md:pl-[42px]" data-id="element-64" data-mp="34xjqnvjye9vk">
                      {tomo.desc}
                    </p>
                  </div>}
              </div>
            </FadeIn>;
      })}
      </div>

      <FadeIn delay={0.4} data-id="element-65" data-mp="1ph2ta7m3czww">
        <div className="bg-bg-card border border-brandOrange/30 rounded-[20px] p-6 md:p-10 max-w-4xl mx-auto" data-id="element-66" data-mp="1phb7c2tyab9o">
          <h3 className="font-display uppercase tracking-[1.5px] text-[20px] md:text-[26px] text-brandOrange text-center leading-snug mb-5 md:mb-8" data-id="element-67" data-mp="1kfvmobvoq6rt">
            Cada nivel incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-3 md:gap-4 mb-6 md:mb-8" data-id="element-68" data-mp="4z0oycga4p91">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-2 md:gap-3" data-id="element-69" data-mp="dqsvwd63hg8v" data-mpi={i}>
                <CheckCircle2 className="text-brandOrange shrink-0 mt-0.5 w-4 h-4 md:w-5 md:h-5" data-id="element-70" data-mp="dsx95lpvvrlt" />
                <span className="font-sans font-medium text-[14px] md:text-[16px] leading-[1.6] text-txt-primary" data-id="element-71" data-mp="is03ab4bsdf0">
                  {feature}
                </span>
              </div>)}
          </div>

          <div className="text-center pt-5 md:pt-6 border-t border-line" data-id="element-72" data-mp="sm8w6zx9q8dp">
            <p className="font-sans font-bold text-base md:text-xl leading-snug text-txt-primary mb-2" data-id="element-73" data-mp="wovpl59l81d0">
              <span className="text-brandOrange" data-id="element-74" data-mp="2uh9ixqvbje8n">Leés.</span>{' '}
              <span className="text-brandOrange" data-id="element-75" data-mp="2yi31s5twm2uo">Aplicás.</span>{' '}
              <span className="text-brandOrange" data-id="element-76" data-mp="5mbal9nm2sa1">Llenás la agenda.</span>
            </p>
            <p className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-primary opacity-80" data-id="element-77" data-mp="ngkdmnbe1fw">
              Todo explicado paso a paso para que empieces a{' '}
              <span className="text-brandOrange font-bold" data-id="element-78" data-mp="eokirsveq9k9">
                atraer clientes.
              </span>
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};
export const Bonuses = () => {
  const bonuses = [{
    num: '01',
    icon: '🎯',
    title: 'Kit de Ofertas Imposibles',
    desc: '25 ofertas listas para activar clientes. Copiás, pegás y publicás.',
    value: '$15.000'
  }, {
    num: '02',
    icon: '📝',
    title: 'Banco de 100 Copys',
    desc: 'Textos listos para Meta Ads, estados de WhatsApp y reactivación.',
    value: '$12.000'
  }, {
    num: '03',
    icon: '✅',
    title: 'Checklist Anuncio en 15 Min',
    desc: 'Revisá cada punto antes de publicar. Sin errores evitables.',
    value: '$10.000'
  }, {
    num: '04',
    icon: '💬',
    title: '60 Respuestas Rápidas WhatsApp',
    desc: 'Atajos para WhatsApp Business. Respondés en 3 segundos.',
    value: '$12.000'
  }, {
    num: '05',
    icon: '📸',
    title: 'Mini Guía de Fotos que Venden',
    desc: 'Los 5 ángulos, la luz y la edición mínima que detiene el scroll.',
    value: '$10.000'
  }, {
    num: '06',
    icon: '📊',
    title: 'Publicidad Rápida IG + FB',
    desc: '3 campañas de tráfico para que el barrio te conozca.',
    value: '$10.000'
  }];
  return <Section className="bg-bg-alt" data-id="element-79" data-mp="tbrkr92wzx70">
      <FadeIn className="text-center mb-8 md:mb-14" data-id="element-80" data-mp="y8rsrpjbra0r">
        <h2 className="font-display font-extrabold uppercase md:text-[52px] text-txt-primary mb-2 md:mb-4 text-[36px]" data-id="element-81" data-mp="y9b24huwsq36">
          + 6 BONOS ESTRATÉGICOS
        </h2>
        <p className="font-sans text-[15px] md:text-[17px] leading-[1.5] md:leading-[1.7] text-txt-primary opacity-70" data-id="element-82" data-mp="p8mq1sp2szsx">
          Incluidos en todas las opciones — sin costo extra
        </p>
      </FadeIn>

      <div className="flex flex-col gap-2 md:gap-3 mb-8 md:mb-12 max-w-3xl mx-auto" data-id="element-83" data-mp="c9lv966n1tdr">
        {bonuses.map((bono, i) => <FadeIn key={i} delay={Math.min(i * 0.04, 0.18)} data-id="element-84" data-mp="7g15u2j427q6" data-mpi={i}>
            <div className="bg-bg-base rounded-[12px] border border-brandOrange/40 px-3 py-2.5 md:px-5 md:py-4 flex items-center gap-3 md:gap-4" data-id="element-85" data-mp="3h222l948h0b">
              {/* Icon block */}
              <div className="shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-[10px] bg-brandOrange/10 border border-brandOrange/30 flex items-center justify-center text-[20px] md:text-[24px]" data-id="element-86" data-mp="3pnqivnzvr19c">
                {bono.icon}
              </div>

              {/* Content */}
              <div className="min-w-0 flex-1" data-id="element-87" data-mp="3govg6lw1o9as">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-88" data-mp="1ixamyieronob">
                  <span className="font-display font-bold uppercase tracking-[1px] text-[10px] md:text-[12px] text-brandOrange" data-id="element-89" data-mp="1evfnljgeckd6">
                    BONO {bono.num}
                  </span>
                </div>
                <h3 className="font-sans font-bold text-[13px] md:text-[16px] text-txt-primary leading-tight mb-0.5 md:mb-1 truncate" data-id="element-90" data-mp="31rvlytc1zt14">
                  {bono.title}
                </h3>
                <p className="hidden md:block font-sans text-[13px] text-txt-primary opacity-70 leading-[1.4]" data-id="element-91" data-mp="3akfpo877cnst">
                  {bono.desc}
                </p>
              </div>

              {/* Price */}
              <div className="shrink-0 flex flex-col items-end gap-0.5" data-id="element-92" data-mp="2isztpnjr9opx">
                <span className="font-sans font-normal text-[11px] md:text-[14px] line-through text-danger" data-id="element-93" data-mp="2ivdorwefr0xh">
                  {bono.value}
                </span>
                <span className="text-success font-sans font-bold uppercase tracking-[0.5px] text-[10px] md:text-[13px]" data-id="element-94" data-mp="2ruqxunyndnho">
                  GRATIS
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} className="max-w-2xl mx-auto pt-3" data-id="element-95" data-mp="75jqk3q242c7">
        <div className="relative text-center bg-bg-card border-2 border-brandOrange p-6 md:p-10 rounded-[20px]" data-id="element-96" data-mp="235abq01dtp9i">
          <span aria-hidden="true" className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brandOrange text-black font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] px-3 py-1 rounded-full whitespace-nowrap shadow-md z-10" data-id="element-97" data-mp="1z509mygpnizx">
            💰 VALOR TOTAL
          </span>
          <p className="font-display uppercase tracking-[1px] text-[20px] md:text-[28px] leading-[1.1] text-txt-primary mt-2 mb-2" data-id="element-98" data-mp="1fhanp7vggcym">
            Valor total de los 6 Bonos
          </p>
          <p className="font-sans font-normal text-[20px] md:text-[28px] line-through text-danger mb-3" data-id="element-99" data-mp="1u89p9yxvi18p">
            $69.000
          </p>
          <p className="font-display font-black text-[28px] md:text-[44px] leading-[1.1] text-brandOrange mb-2" data-id="element-100" data-mp="11pcnjmjq1rel">
            🎁 GRATIS — Solo con tu MEGAPACK
          </p>
          <p className="font-sans text-[13px] md:text-[14px] leading-[1.5] text-txt-primary opacity-80" data-id="element-101" data-mp="38e4tmfui7xkh">
            Incluidos en todas las opciones. Siempre.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const UrgencyCounter = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="bg-bg-base px-4 md:px-6 py-10 md:py-20 overflow-hidden relative" data-id="element-102" data-mp="33ejspzvrxf54">
      {/* Red urgency top stripe */}
      <div className="absolute top-0 left-0 right-0 bg-danger text-white text-center py-1.5 md:py-2 px-3 font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[13px] animate-pulse" data-id="element-103" data-mp="3r5xnechedmt9">
        🚨 ATENCIÓN — ESTA OFERTA NO SE VUELVE A REPETIR
      </div>
      <div className="border-y-2 border-danger absolute inset-x-0 top-0 bottom-0 pointer-events-none" data-id="element-104" data-mp="3n2sm2d91zr67"></div>

      <div className="max-w-[1100px] mx-auto pt-6 md:pt-8" data-id="element-105" data-mp="26o9gol1qv5lt">
        <FadeIn className="max-w-3xl mx-auto" data-id="element-106" data-mp="26qvl4btc94zt">
          <div className="text-center space-y-5 md:space-y-6 max-w-lg mx-auto" data-id="element-107" data-mp="2bo5iqeqvsmyq">
            <div data-id="element-108" data-mp="32egxdbvhgj03">
              <h3 className="font-sans font-bold uppercase tracking-[1.5px] text-[14px] md:text-[16px] text-danger animate-pulse mb-1" data-id="element-109" data-mp="32f0ggvwvddfp">
                ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
              </h3>
              <p className="font-sans text-[12px] md:text-[13px] text-txt-muted" data-id="element-110" data-mp="2tec4e6r1dn5g">
                Cuando llegue a 00:00:00, el precio sube. Punto.
              </p>
            </div>

            <div className="flex justify-center gap-3 md:gap-5 text-brandOrange" data-id="element-111" data-mp="3m27v8utxckub">
              <div className="bg-bg-card border-2 border-danger rounded-[14px] w-[80px] h-[90px] md:w-[100px] md:h-[110px] flex flex-col items-center justify-center shadow-[0_0_30px_rgba(192,57,43,0.4)]" data-id="element-112" data-mp="3h33pke67l58q">
                <div className="font-display font-normal text-[50px] md:text-[80px] leading-none text-brandOrange" data-id="element-113" data-mp="37dk5j56rf5ca">
                  {hours.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] mt-1 text-txt-primary" data-id="element-114" data-mp="3wleuc8tciou">
                  hs
                </div>
              </div>
              <div className="font-display font-normal text-[50px] md:text-[80px] py-2 flex items-center" data-id="element-115" data-mp="g6b2tswvm91u">
                :
              </div>
              <div className="bg-bg-card border-2 border-danger rounded-[14px] w-[80px] h-[90px] md:w-[100px] md:h-[110px] flex flex-col items-center justify-center shadow-[0_0_30px_rgba(192,57,43,0.4)]" data-id="element-116" data-mp="l4uso4elc4zh">
                <div className="font-display font-normal text-[50px] md:text-[80px] leading-none text-brandOrange" data-id="element-117" data-mp="u5swall4aahj">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] mt-1 text-txt-primary" data-id="element-118" data-mp="13xgl0eqahdfb">
                  min
                </div>
              </div>
              <div className="font-display font-normal text-[50px] md:text-[80px] py-2 flex items-center" data-id="element-119" data-mp="1dvmhuhx8ntdb">
                :
              </div>
              <div className="bg-bg-card border-2 border-danger rounded-[14px] w-[80px] h-[90px] md:w-[100px] md:h-[110px] flex flex-col items-center justify-center shadow-[0_0_30px_rgba(192,57,43,0.4)]" data-id="element-120" data-mp="1htkbbwy1l1mi">
                <div className="font-display font-normal text-[50px] md:text-[80px] leading-none text-brandOrange" data-id="element-121" data-mp="2ra7w4l4co1px">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] mt-1 text-txt-primary" data-id="element-122" data-mp="30aw8zci0bw18">
                  seg
                </div>
              </div>
            </div>

            <div className="font-sans font-bold text-[14px] md:text-[16px] text-danger leading-snug" data-id="element-123" data-mp="3a0xym8q0dmi9">
              🔥 Después sube el precio. No vuelve.
            </div>

            <div className="pt-2" data-id="element-124" data-mp="3f1vc4802psdf">
              <div className="flex justify-between font-sans text-[12px] md:text-[14px] leading-[1.5] text-txt-primary mb-2" data-id="element-125" data-mp="3j1w3suc6o02f">
                <span data-id="element-126" data-mp="3o18q9dz5754h">Cupos al precio de lanzamiento</span>
                <span className="text-danger font-bold" data-id="element-127" data-mp="1ccvi41dw8ahn">¡Quedan pocos!</span>
              </div>
              <div className="w-full bg-line rounded-full h-2.5 mb-2 overflow-hidden" data-id="element-128" data-mp="17e0rwedljjni">
                <div className="bg-gradient-to-r from-danger to-brandOrange h-full rounded-full" style={{
                width: '71%'
              }} data-id="element-129" data-mp="17gdfb724im7y"></div>
              </div>
              <p className="font-sans font-bold text-[11px] md:text-[12px] text-danger text-right" data-id="element-130" data-mp="1v3v1mn2mcs3j">
                ⚠️ 71% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const Pricing = () => {
  const [selected, setSelected] = useState<'plus' | 'basic'>('plus');
  const ctaText = selected === 'plus' ? 'SÍ, QUIERO EL SISTEMA COMPLETO' : 'SÍ, QUIERO EL MEGAPACK';
  return <Section className="bg-bg-base !py-8 md:!py-16" id="pricing" data-id="element-131" data-mp="2a0vr0jxc8ayu">
      <FadeIn className="text-center mb-5 md:mb-8" data-id="element-132" data-mp="29zkriwaxdpdj">
        <h2 className="font-display font-extrabold uppercase md:text-[52px] text-txt-primary text-[32px] leading-[1.1]" data-id="element-133" data-mp="2swunfpboe9w9">
          Elegí tu <span className="text-brandOrange" data-id="element-134" data-mp="2xvph5mb6liv5">MEGAPACK:</span>
        </h2>
        <p className="font-sans text-[13px] md:text-[16px] leading-[1.4] text-txt-primary opacity-70 mt-2" data-id="element-135" data-mp="2k5lzl8n8ydc1">
          Todas las opciones incluyen los 6 bonos estratégicos
        </p>
      </FadeIn>

      <div className="max-w-xl mx-auto flex flex-col gap-3 md:gap-4 mb-5 md:mb-7 relative pt-3" data-id="element-136" data-mp="2a6d7ymfutasu">
        {/* Plus option — MÁS ELEGIDO ribbon attached to plus card */}
        <FadeIn delay={0.1} data-id="element-137" data-mp="215yc4t59kdb3">
          <div className="relative" data-id="element-138" data-mp="216q9a8eiej3h">
            {/* MÁS ELEGIDO pill */}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brandOrange text-black font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3.5 py-1 rounded-full whitespace-nowrap z-10" data-id="element-139" data-mp="257a2j0vyp2kc">
              ⭐ MÁS ELEGIDO
            </div>

            <button type="button" onClick={() => setSelected('plus')} aria-pressed={selected === 'plus'} className={`w-full text-left rounded-[14px] md:rounded-[18px] p-4 md:p-5 border-2 transition-all bg-bg-card flex gap-3.5 md:gap-4 items-start ${selected === 'plus' ? 'border-brandOrange' : 'border-line'}`} data-id="element-140" data-mp="3e2pxz7qgz25">
              {/* Radio */}
              <span className={`shrink-0 mt-0.5 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'plus' ? 'border-brandOrange' : 'border-txt-muted'}`} data-id="element-141" data-mp="1svhfybsokar0">
                {selected === 'plus' && <span className="w-2.5 h-2.5 rounded-full bg-brandOrange" data-id="element-142" data-mp="2gmd5t3dksvvm"></span>}
              </span>

              {/* Icon */}
              <span className="text-[22px] md:text-[28px] leading-none shrink-0" data-id="element-143" data-mp="m8lve1nfa7z4">
                🏆
              </span>

              {/* Content */}
              <div className="min-w-0 flex-1" data-id="element-144" data-mp="hblr9wa4vfan">
                <div className="flex items-start justify-between gap-2" data-id="element-145" data-mp="jopilkvlaupu">
                  <h3 className="font-display uppercase tracking-[0.5px] text-txt-primary text-[16px] md:text-[18px] leading-[1.1]" data-id="element-146" data-mp="jqs883stylu1">
                    MEGAPACK +<br data-id="element-147" data-mp="soueaxrf84o6" />
                    <span className={selected === 'plus' ? 'text-brandOrange' : 'text-txt-primary'} data-id="element-148" data-mp="spnf7i3p7zye">
                      POTENCIADORES
                    </span>
                  </h3>
                  <div className="text-right shrink-0" data-id="element-149" data-mp="4x6v720ehxwg">
                    <p className="font-sans text-[11px] md:text-[13px] line-through text-danger leading-tight" data-id="element-150" data-mp="9xuo5t86wotb">
                      $49.990
                    </p>
                    <p className="font-display text-brandOrange text-[22px] md:text-[26px] leading-none" data-id="element-151" data-mp="3dfuz9h91lab5">
                      $24.990
                    </p>
                  </div>
                </div>

                <span className="inline-block bg-success text-white font-sans font-bold uppercase tracking-[0.5px] text-[10px] md:text-[11px] px-2.5 py-0.5 rounded-full mt-1.5 mb-1.5" data-id="element-152" data-mp="3avggvd8nq6ha">
                  AHORRÁS $25.000 🔥
                </span>

                <p className="font-sans text-[12px] md:text-[14px] leading-[1.35] text-txt-primary opacity-90" data-id="element-153" data-mp="30uwda3xo0pvw">
                  6 Tomos + 6 Bonos + ✨{' '}
                  <span className={selected === 'plus' ? 'text-brandOrange font-semibold' : 'text-txt-primary font-semibold'} data-id="element-154" data-mp="2rwawoebr7kxr">
                    6 Potenciadores de Especialización
                  </span>
                </p>
              </div>
            </button>
          </div>
        </FadeIn>

        {/* Basic option */}
        <FadeIn delay={0.2} data-id="element-155" data-mp="289wggt3i7wq7">
          <button type="button" onClick={() => setSelected('basic')} aria-pressed={selected === 'basic'} className={`w-full text-left rounded-[14px] md:rounded-[18px] p-4 md:p-5 border-2 transition-all bg-bg-card flex gap-3.5 md:gap-4 items-start ${selected === 'basic' ? 'border-brandOrange' : 'border-line'}`} data-id="element-156" data-mp="245ygyha9ojwm">
            {/* Radio */}
            <span className={`shrink-0 mt-0.5 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'basic' ? 'border-brandOrange' : 'border-txt-muted'}`} data-id="element-157" data-mp="1pj9hugjxg8qr">
              {selected === 'basic' && <span className="w-2.5 h-2.5 rounded-full bg-brandOrange" data-id="element-158" data-mp="2hcs3fk4m6yxu"></span>}
            </span>

            {/* Icon */}
            <span className="text-[22px] md:text-[28px] leading-none shrink-0" data-id="element-159" data-mp="28hu7s5a3182t">
              📘
            </span>

            {/* Content */}
            <div className="min-w-0 flex-1" data-id="element-160" data-mp="2w6wuhrjkpr46">
              <div className="flex items-start justify-between gap-2" data-id="element-161" data-mp="30zgdj4115egd">
                <h3 className="font-display uppercase tracking-[0.5px] text-txt-primary text-[16px] md:text-[18px] leading-[1.1]" data-id="element-162" data-mp="310rbuobphu03">
                  MEGAPACK{' '}
                  <span className={selected === 'basic' ? 'text-brandOrange' : 'text-txt-primary'} data-id="element-163" data-mp="36bn2of5klrgu">
                    BARBERO PRO
                  </span>
                </h3>
                <div className="text-right shrink-0" data-id="element-164" data-mp="2rf5utxwlauz1">
                  <p className="font-sans text-[11px] md:text-[13px] line-through text-danger leading-tight" data-id="element-165" data-mp="2ndsq5r58gxtp">
                    $34.990
                  </p>
                  <p className="font-display text-brandOrange text-[22px] md:text-[26px] leading-none" data-id="element-166" data-mp="31apb5byo7l2o">
                    $17.990
                  </p>
                </div>
              </div>

              <p className="font-sans text-[12px] md:text-[14px] leading-[1.35] text-txt-primary opacity-90 mt-1.5" data-id="element-167" data-mp="goxjbvno1az5">
                6 Tomos Completos + 6 Bonos incluidos
              </p>
            </div>
          </button>
        </FadeIn>
      </div>

      {/* Pointer + urgency line */}
      <FadeIn delay={0.3} data-id="element-168" data-mp="2a5tgd63otrva">
        <div className="text-center mb-3 md:mb-4 max-w-xl mx-auto" data-id="element-169" data-mp="2f4my5aq0c519">
          <p className="font-sans font-bold text-[13px] md:text-[15px] text-txt-primary mb-1.5" data-id="element-170" data-mp="2f3btz9sngv9m">
            <span className="inline-block mr-1" data-id="element-171" data-mp="2jwo5qjc8d7ky">👇</span>
            Tu próximo lunes empieza acá
          </p>
          <p className="font-sans font-semibold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-brandOrange" data-id="element-172" data-mp="2owk86e5a4qye">
            ⚡ Precio de lanzamiento — Por tiempo limitado
          </p>
        </div>
      </FadeIn>

      {/* Single dynamic CTA */}
      <FadeIn delay={0.35} data-id="element-173" data-mp="32t643jll45q6">
        <div className="max-w-xl mx-auto px-1" data-id="element-174" data-mp="32tfwfdu3qoz1">
          <CTAButton href={PRODUCTS[selected].checkoutUrl} fullWidth trackingProduct={selected} className="!py-4 md:!py-5 !text-[15px] md:!text-[18px]" data-id="element-175" data-mp="13hmvj6470zh1">
            {ctaText}
          </CTAButton>
        </div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-176" data-mp="w5yrecldrcgk">
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 mt-4 md:mt-6 font-sans text-[11px] md:text-[13px] text-txt-primary opacity-80" data-id="element-177" data-mp="w5ox4ctayj52">
          <span data-id="element-178" data-mp="r4syadnt5n6i">🔒 Pago 100% seguro</span>
          <span data-id="element-179" data-mp="m8ka6armujn7">⚡ Acceso en 5 minutos</span>
          <span data-id="element-180" data-mp="m9lwjbe3msk8">🛡️ Garantía 15 días</span>
        </div>
      </FadeIn>
    </Section>;
};
export const Potenciador = () => {
  const comparisons = [{
    bad: 'Llenás la agenda pero el precio es siempre el mismo',
    good: 'Subís el precio un 40% y mantenés los mismos clientes'
  }, {
    bad: 'Dependés 100% de Instagram para tener clientes',
    good: 'Google Maps te trae clientes gratis todos los días'
  }, {
    bad: 'No sabés exactamente cuánto ganás por mes',
    good: 'Claridad total de tus números y margen neto real'
  }, {
    bad: 'Subís fotos y videos que casi nadie ve',
    good: 'Videos que generan 3x más clics que las fotos'
  }, {
    bad: 'Si vos no estás, el negocio para',
    good: 'El local funciona aunque vos no estés'
  }];
  const volumes = [{
    icon: '💰',
    title: 'Upselling Barbero',
    sub: 'Ticket promedio +40%',
    desc: 'Subí tu facturación un 40% vendiendo más a los mismos clientes. Menú VIP, servicios de 5 minutos, membresías y guiones de silla.'
  }, {
    icon: '🗺️',
    title: 'Google Maps Domination',
    sub: 'Clientes gratis desde Google',
    desc: 'Aparecer 1° en tu barrio sin pagar Google. SEO local, sistema de reseñas y dominación de radio.'
  }, {
    icon: '💵',
    title: 'Finanzas del Barbero Empresario',
    sub: 'Libertad financiera',
    desc: 'Flujo de caja, margen neto real, sueldo del dueño y los 4 fondos que cambian todo para siempre.'
  }, {
    icon: '🎬',
    title: 'Video-Ads de Alto Impacto',
    sub: 'CapCut Edition',
    desc: 'El guion de 15 segundos que convierte. Edición rítmica, subtítulos y voiceover con el celular que ya tenés.'
  }, {
    icon: '🤝',
    title: 'Alianzas de Barrio',
    sub: 'Marketing guerrilla',
    desc: 'Que el barrio trabaje para tu barbería. Aliados, cupones cruzados, embajadores y referidos sin depender de Meta Ads.'
  }, {
    icon: '⚙️',
    title: 'Manual de Equipo',
    sub: 'Sistema que funciona sin vos',
    desc: 'SOPs, contratación, capacitación en 15 días, comisiones y el plan de apertura del segundo local.'
  }];
  return <Section className="bg-bg-alt" data-id="element-181" data-mp="3giisy4u2eeyh">
      <FadeIn className="text-center max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-182" data-mp="31oe8ig9m2l14">
        <div className="inline-block font-sans font-bold uppercase tracking-[1px] text-[11px] md:text-[13px] text-brandOrange mb-3 md:mb-4" data-id="element-183" data-mp="36mpkawjgv5lz">
          🚀 ¿QUÉ AGREGAN LOS POTENCIADORES?
        </div>
        <h2 className="font-display font-normal text-[28px] md:text-[40px] leading-[1.1] text-txt-primary mb-3 md:mb-5" data-id="element-184" data-mp="14vcdg1xxunna">
          El Megapack <span className="text-brandOrange" data-id="element-185" data-mp="13f6zv5phktwl">llena tu agenda.</span>
          <br data-id="element-186" data-mp="yf2kxk48878h" />
          Los Potenciadores{' '}
          <span className="text-brandOrange" data-id="element-187" data-mp="yeatmlhnwvo0">construyen el Imperio.</span>
        </h2>
        <p className="font-sans text-[13px] md:text-[16px] leading-[1.5] text-txt-primary opacity-70" data-id="element-188" data-mp="th0ycp7ldps9">
          6 volúmenes de especialización para el barbero que no se conforma con
          lo básico.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} className="max-w-6xl mx-auto mb-12 md:mb-16" data-id="element-189" data-mp="1m3vkdqk24x7u">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-3.5 mb-8 md:mb-10" data-id="element-190" data-mp="1h6vbl7vtpgd1">
          {volumes.map((vol, i) => <div key={i} className="bg-bg-base border border-brandOrange/30 rounded-[12px] md:rounded-[14px] p-3.5 md:p-4 hover:border-brandOrange transition-all flex flex-col" data-id="element-191" data-mp="1cchen11ij169" data-mpi={i}>
              <div className="flex items-center gap-2.5 md:gap-3 mb-2 md:mb-2.5" data-id="element-192" data-mp="203whqw145mik">
                <div className="text-[20px] md:text-[26px] shrink-0" data-id="element-193" data-mp="3ir6504syn5h8">
                  {vol.icon}
                </div>
                <div className="min-w-0" data-id="element-194" data-mp="3npr5m5c4jr67">
                  <h4 className="font-sans font-bold text-[14px] md:text-[15px] leading-[1.2] text-txt-primary" data-id="element-195" data-mp="3nqj1lh9mvqx0">
                    {vol.title}
                  </h4>
                  <p className="font-sans font-medium text-[11px] md:text-[12px] text-brandOrange" data-id="element-196" data-mp="ltcn49c30et">
                    {vol.sub}
                  </p>
                </div>
              </div>
              <p className="font-sans text-[12px] md:text-[13px] leading-[1.4] text-txt-primary opacity-75 mb-2.5 flex-grow" data-id="element-197" data-mp="aixskmcl5zn6">
                {vol.desc}
              </p>
              <div className="font-sans font-medium text-[10.5px] md:text-[11.5px] text-txt-muted pt-2 border-t border-line" data-id="element-198" data-mp="jc1c9cdtr8q9">
                50 páginas · Sistema completo
              </div>
            </div>)}
        </div>

        <div className="bg-bg-base border border-brandOrange/30 rounded-[20px] p-5 md:p-7 text-center max-w-3xl mx-auto" data-id="element-199" data-mp="tba49zp4qd9z">
          <p className="font-display font-normal text-[22px] md:text-[30px] leading-[1.15] text-brandOrange mb-1.5" data-id="element-200" data-mp="flxb4ma2sw8t">
            Total: 6 volúmenes · 300 páginas adicionales
          </p>
          <p className="font-sans text-[13px] md:text-[15px] leading-[1.5] text-txt-primary opacity-80" data-id="element-201" data-mp="pc010dlwhu2x">
            Para el barbero que quiere crecer de verdad.
          </p>
        </div>
      </FadeIn>

      <div className="max-w-4xl mx-auto" data-id="element-202" data-mp="3sutden2y0cvi">
        <div className="bg-bg-base rounded-[16px] md:rounded-[20px] overflow-hidden border border-line p-4 md:p-8" data-id="element-203" data-mp="3nuyk6cvp3b7a">
          <div className="grid grid-cols-2 gap-3 md:gap-8 mb-3 md:mb-5" data-id="element-204" data-mp="6ncwbw7mz6pv">
            <div className="font-sans font-bold text-[13px] md:text-[18px] text-danger" data-id="element-205" data-mp="6kgzycbfsq3j">
              ❌ Sin Potenciadores
            </div>
            <div className="font-sans font-bold text-[13px] md:text-[18px] text-success" data-id="element-206" data-mp="1i179a4b5py1d">
              ✅ Con Potenciadores
            </div>
          </div>
          <div className="space-y-2.5 md:space-y-5" data-id="element-207" data-mp="1d58d3ujl7bqe">
            {comparisons.map((row, i) => <div key={i} className="grid grid-cols-2 gap-3 md:gap-8" data-id="element-208" data-mp="1korefgwp7rns" data-mpi={i}>
                <div className="font-sans text-[11.5px] md:text-[16px] leading-[1.35] md:leading-[1.6] text-txt-primary opacity-70 flex items-start gap-1.5" data-id="element-209" data-mp="1pn2mpn7chu3w">
                  <span className="text-danger shrink-0 text-[11px] md:text-base" data-id="element-210" data-mp="1fmse6fw99av2">
                    ❌
                  </span>{' '}
                  {row.bad}
                </div>
                <div className="font-sans text-[11.5px] md:text-[16px] leading-[1.35] md:leading-[1.6] text-txt-primary flex items-start gap-1.5" data-id="element-211" data-mp="28bps66tfoli0">
                  <span className="text-success shrink-0 text-[11px] md:text-base" data-id="element-212" data-mp="1uk2wa83elezr">
                    ✅
                  </span>{' '}
                  {row.good}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
};